/**
 * 全局公用方法
 *
 * @type {{toast(string, string=, int=, Function=): void, confirm(string, string, string=, string=, Function=, Function=): void}}
 */
const global = {
  /**
   * 用来显示「成功、警告、消息、错误」类的操作反馈
   *
   * @param {string} message 提示信息
   * @param {string} type 类别可选参数：success/warning/info/error
   * @param {int} duration 显示时长 单位：毫秒
   * @param {function} onClose 关闭时回调函数
   */
  toast(message, type = 'success', duration = 1000, onClose = null) {
    let option = { message, type, duration };

    if (typeof onClose === 'function') {
      option.onClose = onClose;
    }

    Bus.$message(option);
  },
  /**
   * confirm提示框
   *
   * @param {string} message 提示信息
   * @param {string} title 提示标题
   * @param {function} confirmCallBack 确认回调
   * @param {function} cancelCallBack 取消回调
   * @param {string}  confirmButtonText 确认按钮文字
   * @param {string}  cancelButtonText 取消按钮文字
   */
  confirm(
    message,
    title,
    confirmCallBack = null,
    cancelCallBack = null,
    confirmButtonText = '确定',
    cancelButtonText = '取消'
  ) {
    let option = {
      title,
      confirmButtonText,
      cancelButtonText,
      showCancelButton: true,
      showConfirmButton: true,
      lockScroll: true,
      showClose: true,
      closeOnPressEscape: true,
      callback(action) {
        if (action === 'confirm' && typeof confirmCallBack === 'function') {
          confirmCallBack();
        }
        if (action === 'cancel' && typeof cancelCallBack === 'function') {
          cancelCallBack();
        }
      }
    };

    Bus.$alert(message, option);
  },
  /**
   * 路径截取方法
   * 去掉路径中的"upload/ "字段
   *  url 为需要截取的字符串
   *
   * */
  pathIntercept(url) {
    url.trim();
    let num = url.indexOf('upload/');
    let path = url;
    if (num !== -1) {
      path = url.substring(num + 7, url.length);
    }
    return path;
  },
  /**
   * 阻止浏览器刷新和关闭
   *
   * @param {string}} msg
   */
  windowBeforeUnload(msg) {
    window.onbeforeunload = e => {
      e = e || window.event;

      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = msg;
      }

      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return msg;
    };
  },

  validate: {
    positiveInteger(value) {
      let reg = /^[1-9]{1}[0-9]*$/; //判断字符串是否为正整数
      return reg.test(value);
    },

    positiveIntegerForm(rule, value, callback) {
      if (!this.positiveIntegerForm(value)) {
        callback(new Error('请输入正整数'));
      }
    }
  },
  checkAction(actionId) {
    let userAllActions = lockr.get('user_actions') || [];

    return userAllActions.indexOf(actionId) >= 0;
  },

  //数字加密
  encryption(num){
    let key = 34;
    let arr = num.split('.');
    let re = [];
    arr.forEach((item,k)=>{
      let temp = '';
      let len = item.length;
      for(var i = 0; i < len; i++){
        let tempNUm = item.substr(i,1);
        temp += (tempNUm == '-' ? '-' : tempNUm ^ key);
      }
      re.push(temp);
    });
    return re.join('.');
  },

  //数字解密
  decryption(num){
    let key = 34;
    let arr = num.split('.');
    let re = [];
    arr.forEach((item,k)=>{
      let temp = '';
      if(item.substr(0,1) == '-'){
        temp += '-';
        item = item.substr(1,item.length-1);
      }
      let len = item.length;
      for(var i = 0; i < len; i+=2){
        temp += item.substr(i,2) ^ key;
      }
      re.push(temp);
    });
    return re.join('.');
  },

  formatNumber(num) {
    if(typeof num === 'undefined' || num === null){
      return '';
    }
    num = num + '';
    if (num.indexOf(',') >= 0) {
      return num;
    }
    if (num.length <= 0) return num;

    let float = parseFloat(num).toFixed(3);
    return float.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
};

export default global;



// WEBPACK FOOTER //
// ./src/global.js